import call from './httpClient';

const BASE_URL = `${import.meta.env.VITE_APP_API_URL}/v1/product-categories`;

// eslint-disable-next-line import/prefer-default-export
export const Get = async () => call({
  url: BASE_URL,
  method: 'GET',
});
